export async function preventSwipeToClose(data?: any, role?: string): Promise<boolean>{
  return role !== 'gesture';
}